export const PUBLISHERS_URL = 'publisher';

export const PUBLISHER_FILE_UPLOAD_URL = 'publisher/upload';
